/* eslint-disable */
import {
  Flex,
  Form,
  Input,
  Checkbox,
  Modal,
  Select,
  Table,
  Space,
  Button,
  Tooltip,
  Radio,
  message,
  Tag,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.css";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

import { useLocation } from "react-router-dom";
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);

  const initTableHead = {
    propUnit: null,
    vendorName: null,
    jobType: null,
    payAmount: null,
    predictCompletionTime: null,
    requestDate: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: 'Pay Amount',
      dataIndex: "payAmount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'payAmount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={(e) => {
              if (!record || record.maintenanceId == null) return;

              const u = new URL(window.location.href);
              const route = '/JobRequests/Maintenance/Details';
              const qs = new URLSearchParams({ id: String(record.maintenanceId) }).toString();
              u.hash = `${route}?${qs}`;

              window.open(u.toString(), '_blank', 'noopener,noreferrer');
            }}
            className="CA-AS-AmountStyle"
          >
            {commonFn.amountToDollarFn(text)}
          </span>
        );
      },
    },
    {
      title: 'Prop - Address City - Units',
      dataIndex: "addressCity",
      titleType: 'Input',
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'addressCity'),
    },
    {
      title: 'Vendor',
      dataIndex: "vendorName",
      titleType: 'Input',
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName'),
      render: (text, record) => (
        <>
          <div>{text}</div>
          <div>{record.role}</div>
        </>
      ),
    },
    {
      title: "GL-Title",
      dataIndex: "glAcct",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    // {
    //   title: 'Vendor Role',
    //   dataIndex: "role",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'role')
    // },
    {
      title: 'Pay Remark ',
      dataIndex: "payRemark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'payRemark'),
    },
    {
      title: 'Repair Remark',
      dataIndex: "remark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'remark'),
    },
    {
      title: "Job Type",
      dataIndex: "jobTypeName",
      titleType: "",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobType"),
      width: 200,
      render: (text) => (
        <Flex gap="4px 0" wrap>
          {text?.map((item) => (
            <Tooltip title={item}>
              <Tag
                  // color="rgba(109, 140, 81, 0.12)"
                color="blue"
                style={{
                    // color: "#6D8C51",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor'),
    },
    // {
    //   title: 'Request Number',
    //   dataIndex: "requestNo",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'requestNo'),
    //   render: (text, record) => {
    //     return (
    //       <span
    //         onClick={(e) => {
    //           if (!record || record.maintenanceId == null) return;

    //           const u = new URL(window.location.href);
    //           const route = '/JobRequests/Maintenance/Details';
    //           const qs = new URLSearchParams({ id: String(record.maintenanceId) }).toString();
    //           u.hash = `${route}?${qs}`;

    //           window.open(u.toString(), '_blank', 'noopener,noreferrer');
    //         }}
    //         className="CA-AS-AmountStyle"
    //       >
    //         {text}
    //       </span>
    //     )
    //   }
    // },
    {
      title: 'Status',
      dataIndex: "vpStatus",
      titleType: '',
      width: 140,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vpStatus'),
      render: (text, record) => (
        <>
          <div>{text}</div>
          <div>{record.udate}</div>
        </>
      ),
    },
  ]

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      page: current || pagination.current ,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
    };

    const response = await http.get(api.getCheckMainContractor, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
  
  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const [btnLoading, setBtnLoading] = useState(false);
  
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    // 验证表单
    const values = await approvalForm.validateFields();
    
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };

  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('DetailDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnGreen" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnWarning" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('Rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnGreen" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.payAmount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollX={undefined}
        tableCss="maintenanceTable"
      />

      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        maskClosable={false}
        open={openApproval}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item>

          {approvedOrRejected !=='Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item>}
        </Form>
      </Modal>

    </div>
  );
});
export default MainTable;
